// Mock data for the quote generator
export const mockData = {
  formes: [
    'Rond',
    'Carré', 
    'Rectangle'
  ],
  
  couleurs: [
    'Rouge',
    'Bleu',
    'Vert',
    'Noir',
    'Blanc',
    'Jaune',
    'Gris',
    'Orange',
    'Violet'
  ],
  
  // Dimensions et prix exacts selon le site
  dimensionsWithPrices: {
    '40 mm': 1.75,
    '40x40 mm': 2.10,
    '80x30 mm': 2.50,
    '100x50 mm': 4.10,
    '150x50 mm': 5.50,
    '150x100 mm': 8.50,
    '200x150 mm': 13.50,
    '200x300 mm': 18.00
  },
  
  // Dimensions par forme avec cohérence logique (max 300x500mm)
  dimensionsByForme: {
    'Rond': ['40 mm'],
    'Carré': ['40x40 mm'],
    'Rectangle': ['80x30 mm', '100x50 mm', '150x50 mm', '150x100 mm', '200x150 mm', '200x300 mm']
  },
  
  // Toutes les dimensions disponibles (max 300x500mm)
  dimensions: ['40 mm', '40x40 mm', '80x30 mm', '100x50 mm', '150x50 mm', '150x100 mm', '200x150 mm', '200x300 mm'],
  
  // Plus besoin de données schémas
  
  // Base pricing (maintenant utilise les prix fixes)
  basePricing: {
    baseShape: 'rond',
    baseDimension: '40 mm',
    basePrice: 1.75
  },
  
  // Sociétés et leurs agences
  companiesData: {
    "AAI": {
      agencies: [
        "AAI Aix-en-Provence - Immeuble Le Trident, 760 rue Jean Perrin, 13290 AIX EN PROVENCE",
        "AAI Nice - ESPACE ST LAURENT, 635 avenue Général de Gaulle, 06700 Saint Laurent du Var",
        "AAI Paris Nord - 50-54 Avenue du Vieux Chemin de Saint Denis, 92390 VILLENEUVE LA GARENNE",
        "AAI Paris Sud - 6 rue des Petits Ruisseaux, Z.A. des Godets, 91370 VERRIERES LE BUISSON",
        "AAI Lyon - 29 av. de la Zac de Chassagne, 69360 TERNAY",
        "AAI Toulouse - Centre de Gros Larrieu, 8 rue Gaston Evrard, 31094 TOULOUSE Cedex 1",
        "AAI Lille - 82 av. de la République, 59113 SECLIN",
        "AAI Caen - Parc d'activités Espace Cardonville, Voie des alliés, 14740 BRETTEVILLE L'ORGUEILLEUSE",
        "AAI Nancy - 6 rue de l'Epinette, ZAC de la Solère, 54420 SAULXURES LES NANCY",
        "AAI Orléans - 37 rue de Bernard Million, 45140 SAINT JEAN DE LA RUELLE",
        "AAI Poitiers - 16 rue de la République, 86000 POITIERS",
        "AAI Saint-Nazaire - 8 rue Louis Bréguet, 44600 ST NAZAIRE",
        "AAI Monaco - Le Panorama A/B, 57 Rue Grimaldi, 98000 MONACO",
        "AAI Castets (Siège) - 92 rue de Lesté, 40260 CASTETS",
        "AAI Martinique - 20 Allée des Cocotiers, Quartier Mansarde, 97231 LE ROBERT",
        "AAI Réunion - 4 rue Franck Camille Cadet Zie les Sables, 97427 L'Etang Sale"
      ]
    }
    // Possibilité d'ajouter d'autres sociétés ici
  },

  // Mock company settings
  companySettings: {
    email: 'tok.and@outlook.fr',
    companyName: 'ToK\'anD',
    address: '60, rue François 1er, 75008 Paris, FRANCE',
    vatRate: 20
  }
};